import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background-color":"#f5f5f5","overflow":"hidden","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "feedback comBox" }
const _hoisted_3 = {
  key: 1,
  style: {"background":"#ccc","text-align":"center","width":"150px","height":"150px"}
}
const _hoisted_4 = { class: "img-text" }

import { UploadFilled } from "@element-plus/icons-vue";
import { reactive, ref } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
import url from "@/assets/module_share_open.png";
import type { FormInstance, FormRules } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'feedback',
  setup(__props) {

const upload_action = ref(serverBaseUrl + "/file/upload");
const userList = JSON.parse(localStorage.getItem("userList"));
document.title = "标识山西-意见反馈";
const ruleForm = ref({
  remarks: "",
  filePath: "",
  createUser: "",
  avatar: ""
});
const ruleFormRef = ref()
const fileList = ref([]);
const regex = /(.+)_.*(\..+)/;
const rules = reactive<any>({
  remarks: [{ required: true, message: "请输入问题描述", trigger: "change" }],
  filePath: [{ required: true, message: "请上传问题证明", trigger: "change" }],
});
const submit = () => {
  ruleForm.value.createUser = userList.memberId;
  ruleForm.value.avatar = userList.avatar;
  ruleFormRef.value.validate((valid: boolean) => {
    if (valid) {
      Axios(
        "post",
        "/system/advice",
        ruleForm.value,
        false,
        function (res) {
          console.log(res);
          if (res.data.code == 200) {
            ElMessage({
              message: '提交成功！',
              type: 'success',
            })
            ruleForm.value = {
              remarks: "",
              filePath: "",
              createUser: "",
              avatar: ""
            };
            fileList.value = [];
            ruleFormRef.value.resetFields();
          } else {
            ElMessage({
              message: res.data.msg,
              type: 'error',
            })
          }

        }
      );
    } else {
      ElMessage.warning("请填写完整信息");
    }
  });
}
// 上传成功
const onSuccess = (res: any, file: any, fileList1: any) => {
  console.log(res, file, fileList1);
  fileList.value.push({
    url: res.data.url,
    name: res.data.name,
    name1: res.data.name.split("?")[0],
  });
  ruleForm.value.filePath = res.data.url;
};
// // 删除图片
const handleRemove = (file, fileList1, type) => {
  fileList.value = [];
  ruleForm.value.filePath = null;
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm.value,
        "label-width": "100px",
        rules: rules,
        class: "demo-ruleForm",
        size: _ctx.formSize,
        "status-icon": "",
        "label-position": "left"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "问题描述",
            prop: "remarks"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                autosize: { minRows: 4, maxRows: 6 },
                maxlength: 500,
                "show-word-limit": "",
                modelValue: ruleForm.value.remarks,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.value.remarks) = $event)),
                placeholder: "请输入问题描述"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "问题证明",
            prop: "filePath"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "hidden",
                modelValue: ruleForm.value.filePath,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.value.filePath) = $event))
              }, null, 8, ["modelValue"]),
              (fileList.value.length == 0)
                ? (_openBlock(), _createBlock(_component_el_upload, {
                    key: 0,
                    class: "upload-demo",
                    drag: "",
                    action: upload_action.value,
                    "on-success": onSuccess,
                    "on-remove": handleRemove,
                    ref: "upload",
                    "file-list": fileList.value,
                    "show-file-list": false,
                    limit: 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(UploadFilled))
                        ]),
                        _: 1
                      }),
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "el-upload__text" }, [
                        _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#333333"} }, " 点击或拖拽文件到此处上传 "),
                        _createElementVNode("div", { style: {"font-size":"0.12rem","color":"#86909c"} }, "上传相关图片")
                      ], -1))
                    ]),
                    _: 1
                  }, 8, ["action", "file-list"]))
                : _createCommentVNode("", true),
              (fileList.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_el_image, {
                      style: {"width":"150px","height":"150px"},
                      fit: "fit",
                      src: fileList.value[0].url,
                      "preview-src-list": [fileList.value[0].url]
                    }, null, 8, ["src", "preview-src-list"]),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(fileList.value[0].name1.match(regex)[1] +
                "" +
                fileList.value[0].name1.match(regex)[2]), 1),
                    _createVNode(_component_el_image, {
                      src: _unref(url),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (handleRemove())),
                      class: "img-Off"
                    }, null, 8, ["src"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "size"]),
      _createElementVNode("div", {
        class: "dataBtn",
        onClick: submit
      }, "提交")
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"height":"1.34rem"} }, null, -1))
  ]))
}
}

})